module.exports = __webpack_public_path__ + "static/media/logo.262944fd.png";